module.exports = __webpack_public_path__ + "static/media/y-place.85fd34f2.svg";